import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormButton, FDN } from '@intersystems/isc-form';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-deployment-update-dialog',
  templateUrl: './deployment-update-dialog.component.html',
})
export class DeploymentUpdateDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DeploymentUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  FDN: FDN = {
    name: 'Update Deployment',
    validateOn: 'change',
    sectionLayout: { showSectionHeaders: false },
    sections: [
      {
        fields: [
          {
            id: 'deploymentName',
            key: 'deploymentName',
            type: 'input',
            viewOnly: true,
            templateOptions: {
              label: 'Deployment name',
            },
            data: {},
          },
          {
            id: 'snapShotId',
            key: 'snapShotId',
            type: 'input',
            viewOnly: true,
            templateOptions: {
              label: 'Target Snapshot: ',
            },
            data: {
              displayField: 'snapShotId',
            },
          },
          {
            id: 'confirmation',
            key: 'confirm',
            type: 'input',
            templateOptions: {
              label: 'Type "' + this.data.deploymentName + '" in the box below to update deployment (case-sensitive)',
            },
            hintText:
              'System will be unavailable during a system update. Are you sure you want to update the following deployment?',
            wrappers: ['hint-info'],
          },
        ],
      },
    ],
  };

  buttons: FormButton[] = [
    {
      text: 'Cancel',
      buttonClass: 'secondary',
      id: 'cancel',
      type: 'submit',
      callback: () => this.dialogRef.close(false),
    },
    {
      text: 'Update',
      buttonClass: 'primary',
      id: 'update',
      type: 'submit',
      disabled: (_formModel: any, _formOptions: any, form: any) =>
        form.valueChanges.pipe(map((formModel: any) => formModel.confirm != this.data.deploymentName)),
      callback: (_event, _button, formModel) => this.dialogRef.close(formModel),
    },
  ];

  ngOnInit(): void {
    // remove extra spaces
    this.data.deploymentName = this.data.deploymentName.replace(/\s+/g, ' ').trim();
  }
}
